import '../scss/bootstrap.scss';
import 'bootstrap/js/src/offcanvas';
import 'bootstrap/js/src/collapse';
import Popover from 'bootstrap/js/src/popover';

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
[...popoverTriggerList].map((popoverTriggerEl) => new Popover(popoverTriggerEl));
